<template>    
  <div class="background_basic">            
    <v-card class="ma-3">
      <v-toolbar dense flat color="white">
        <v-toolbar-title class="grey--text text--darken-3">
          <v-icon class="mr-2">mdi-signal</v-icon>Sensor
        </v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-btn color="blue" text @click="initialize()" class="font-weight-bold text-subtitle-1">
          <v-icon big class="mr-2">refresh</v-icon>초기화
        </v-btn>
        <v-btn color="blue" text @click="ExcelExpert('Sensor')" class = "ml-2 font-weight-bold text-subtitle-1">
          <v-icon big class="mr-2">mdi-microsoft-excel</v-icon>엑셀
        </v-btn>
        <v-spacer></v-spacer>

        <!-- <v-btn color="blue" text @click="uploadExcel()" class = "ml-2 font-weight-bold text-subtitle-1">
          <v-icon big class="mr-2">mdi-cloud-upload-outline</v-icon>엑셀업로드
        </v-btn> -->

        <v-dialog v-model="dialog" max-width="600px">
          <template v-slot:activator="{ on }">
            <v-btn color="blue" text v-on="on" :disabled="!ProgramPermissionInfo.okC" @click="ClearDialog()" class="font-weight-bold text-subtitle-1">
              <v-icon big class="mr-2">post_add</v-icon>신규등록
            </v-btn>
          </template>
          <v-card ref="form">
            <v-card-title >
              <span class="font-weight-bold">{{ formTitle }}</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row class="ma-0">                  
                  <v-col cols="12" sm="6" md="6" >
                    <v-text-field dense v-model="editedItem.cSensorId" label="Mac" maxlength="50" hint="필수항목" persistent-hint :disabled="editedIndex != -1"></v-text-field>
                  </v-col>                  
                  <v-col cols="12" sm="6" md="6" >
                    <v-text-field dense v-model="editedItem.cSensorNm" label="Sensor명" maxlength="50" ></v-text-field>
                  </v-col>                  
                  <v-col cols="12" sm="6" md="6">
                    <v-select dense v-model="editedItem.cUse" label="사용여부" :items="zUse"  item-value="sId" item-text="sNm"></v-select>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>                
              <v-spacer></v-spacer>
              <v-btn color="blue darken-2" text @click="save" :disabled="loading" class="font-weight-bold text-subtitle-1">
                <v-icon big class="mr-2">save</v-icon>저장
              </v-btn>
              <v-btn color="grey darken-2" text @click="close" :disabled="loading" class="font-weight-bold text-subtitle-1">
                <v-icon big class="mr-2">cancel</v-icon>취소
              </v-btn>
            </v-card-actions>              
            <v-progress-linear :active="loading" :indeterminate="loading" absolute bottom color="blue accent-4"></v-progress-linear>
          </v-card>
        </v-dialog>
      </v-toolbar>      

      <v-divider></v-divider>
    
      <v-card flat class="d-flex ml-3 mr-3">                
        <v-card class="ml-3 mb-1" flat style="max-width:150px;">   
          <v-select v-model="cNowCheck" class="mb-n5" label="배정여부" :items="zMappingAll" item-value="sId" item-text="sNm" @change="Search()"></v-select>   
        </v-card>           
        <v-text-field
          v-model="cNowSearchKeyWord"
          class="ml-3 mb-n5"
          label="검색어"
          placeholder="Mac 입력"
          persistent-placeholder
          style="max-width:250px;"
          Regular
          v-on:keyup.enter="Search()"
        ></v-text-field>
        
        <v-btn icon class="ml-n8 mt-3 text-subtitle-1" @click="Search()">
          <v-icon>search</v-icon>
        </v-btn>
      </v-card>    
      <v-divider></v-divider>

      <v-data-table         
        :items-per-page="15" 
        fixed-header 
        height="calc(100vh - 247px)" 
        :headers="headers" 
        :items="Records"
        @dblclick:row="handleDoubleClick">
        <template v-slot:item.action="{ item }">          
          <v-icon big class="mr-0" @click="editItem(item)" :disabled="!ProgramPermissionInfo.okU">edit</v-icon>
          <v-icon big @click="deleteItem(item)" :disabled="!ProgramPermissionInfo.okD">delete</v-icon>
        </template>

        <template v-slot:item.cMapId="{ item }">
          <v-chip v-if="(item.cMapId == 'NN') " color="red lighten-2" small label dark @click="goApInfoPage()">미배정
            <v-icon big class="ml-1 mr-n1">mdi-chevron-right</v-icon>
          </v-chip>
          <v-chip v-else small label color="grey lighten-3" @click="goApInfoPage()">배정
            <v-icon big class="ml-1 mr-n1">mdi-chevron-right</v-icon>
          </v-chip>
        </template> 

        <template v-slot:item.cUse="{ item }">
          <v-chip v-if="item.cUse == 'Y' " small label color="grey lighten-3">사용</v-chip>
          <v-chip v-else small color="grey darken-3" label dark>미사용</v-chip>
        </template> 

        <template v-slot:item.cState="{ item }">
          <v-chip v-if="item.cState == 'ON' " small label color="grey lighten-3">ON</v-chip>
          <v-chip v-else-if="item.cState == 'OFF' " small label color="red lighten-2" dark>OFF</v-chip>
          <v-chip v-else-if="item.cState == 'ERR' " small label color="orange lighten-2" dark>Error</v-chip>
          <v-chip v-else small color="grey darken-3" label dark>{{item.cState}}</v-chip>
        </template> 
        
        <template v-slot:no-data>
          <p>No data available.</p>
        </template>
      </v-data-table>
    </v-card>
  
    <MsgBox ref="MsgBoxRef" @onMsgBox="onMsgBoxFunc" />    
    
    <!-- <UploadExcel ref="UploadExcelRef" @onReadFile="onReadFile"/> 

    <v-dialog max-width="2048px" v-model="bReadFile">
      <v-card >              
        <v-toolbar dense flat color="white">
          <v-toolbar-title class="grey--text text--darken-3">
            <v-icon>mdi-cloud-upload-outline</v-icon>
            엑셀 업로드
          </v-toolbar-title>          
          <v-divider class="mx-4" inset vertical></v-divider>                    
        </v-toolbar>
        <v-data-table 
          :items-per-page="-1" 
          fixed-header 
          height="calc(100vh - 300px)" 
          :headers="Fileheaders" 
          :items="FileRecords"          
          >                  
          <template v-slot:item.cUse="{ item }">
            <v-chip v-if="item.cUse == 'Y'" color="grey lighten-3" label small>사용</v-chip>
            <v-chip v-if="item.cUse == 'N'" color="red darken-4" label small dark>중지</v-chip>
          </template>
          <template v-slot:item.cLocked="{ item }">
            <v-chip v-if="item.cLocked == 'Y'" color="red darken-3" label small dark>잠금</v-chip>
            <v-chip v-if="item.cLocked == 'N'" color="grey lighten-4" label small>정상</v-chip>
          </template>
          <template v-slot:no-data>
            <p>No data available.</p>
          </template>
  
        </v-data-table>

        <v-divider></v-divider>
        <v-progress-linear :active="loading2" :indeterminate="loading2" absolute bottom color="blue accent-4"></v-progress-linear>
        <v-card-actions>
          <v-spacer></v-spacer> 
          <v-btn color="black darken-1" text @click="uploadExcelFile()" :disabled="FileRecords.length == 0"><v-icon class="mr-2">mdi-upload</v-icon>확인</v-btn>        
          <v-btn color="black darken-1" text @click="bReadFile=false"><v-icon class="mr-2">mdi-close</v-icon>닫기</v-btn>        
        </v-card-actions>
      </v-card>    
    </v-dialog>       -->
  </div>
</template>

<script>
import MsgBox from "../components/MsgBox.vue";
import BasicInfo from "../BasicInfo.js";
import Util from "../Util.js";
import axios from "axios";
import { mapState } from "vuex";
import XLSX from 'xlsx';
import EventBus from '@/eventBus.js';
import router from "../router";
// import UploadExcel from "@/components/UploadExcel.vue";  


export default {
  components: {
    MsgBox,
    // UploadExcel,    
  },
  data: () => ({
    bReadFile : false,
    cNowSearchKeyWord : "",
    cNowCheck: "A",
    loading : false,
    loading2 : false,
    isEditMode : false,
    iDelIndex: 0,
    dialog: false,    
    FileRecords : [],
    Fileheaders: [      
      { class: "font-weight-bold subtitle-2", text: "Id", value: "cId", align: "center" },      
      { class: "font-weight-bold subtitle-2", text: "Mac", value: "cMac", align: "center"},
      { class: "font-weight-bold subtitle-2", text: "Type", value: "cType", align: "center" },      
      { class: "font-weight-bold subtitle-2", text: "IP", value: "cIp", align: "center", },
      { class: "font-weight-bold subtitle-2", text: "Port", value: "cPort", align: "center",},
      { class: "font-weight-bold subtitle-2", text: "InOut", value: "cInOut", align: "center", },
      { class: "font-weight-bold subtitle-2", text: "Server", value: "cServer", align: "center",},
      { class: "font-weight-bold subtitle-2", text: "PowerId", value: "cPowerId", align: "center", },
      { class: "font-weight-bold subtitle-2", text: "LimitRSSI", value: "cLimitRSSI", align: "center", },
      { class: "font-weight-bold subtitle-2", text: "Count", value: "cCount", align: "center",},
      { class: "font-weight-bold subtitle-2", text: "사용여부", value: "cUse", align: "center",},
    ],  
    headers: [            
      { class: "font-weight-bold subtitle-2", text: "Mac", value: "cSensorId", align: "center", width:150},
      { class: "font-weight-bold subtitle-2", text: "Sensor명", value: "cSensorNm", align: "center", width:150},
      { class: "font-weight-bold subtitle-2", text: "위치", value: "cMapFullNm", align: "center", width:150},
      // { class: "font-weight-bold subtitle-2", text: "Type", value: "cType", align: "center" },
      { class: "font-weight-bold subtitle-2", text: "State", value: "cState", align: "center" },
      { class: "font-weight-bold subtitle-2", text: "작업", value: "action", align: "center", sortable: false, width:130},      
      { class: "font-weight-bold subtitle-2", text: "배정여부", value: "cMapId", align: "center" },
      { class: "font-weight-bold subtitle-2", text: "사용여부", value: "cUse", align: "center" },      

      { class: "font-weight-bold subtitle-2", text: "RSSI", value: "fRssi", align: "center" },
      { class: "font-weight-bold subtitle-2", text: "PowerLev", value: "cTX_POWER_Lev", align: "center" },
      { class: "font-weight-bold subtitle-2", text: "PowerData", value: "cTX_POWER_Data", align: "center" },
      { class: "font-weight-bold subtitle-2", text: "온도Lev", value: "cTEMPERATURE_Lev", align: "center" },
      { class: "font-weight-bold subtitle-2", text: "온도", value: "cTEMPERATURE_Data", align: "center" },
      { class: "font-weight-bold subtitle-2", text: "HUMIDTY_Lev", value: "cHUMIDTY_Lev", align: "center" },
      { class: "font-weight-bold subtitle-2", text: "HUMIDTY", value: "cHUMIDTY_Data", align: "center" },
      { class: "font-weight-bold subtitle-2", text: "BATTERY_Lev", value: "cBATTERY_Lev", align: "center" },
      { class: "font-weight-bold subtitle-2", text: "BATTERY", value: "cBATTERY_Data", align: "center" },
      { class: "font-weight-bold subtitle-2", text: "VIBRATION_Lev", value: "cVIBRATION_Lev", align: "center" },
      { class: "font-weight-bold subtitle-2", text: "VIBRATION", value: "cVIBRATION_Data", align: "center" },
      { class: "font-weight-bold subtitle-2", text: "OXYGEN_Lev", value: "cSENS_OXYGEN_Lev", align: "center" },
      { class: "font-weight-bold subtitle-2", text: "OXYGEN", value: "cSENS_OXYGEN_Data", align: "center" },
      { class: "font-weight-bold subtitle-2", text: "CARBON_MONOXIDE_Lev", value: "cSENS_CARBON_MONOXIDE_Lev", align: "center" },
      { class: "font-weight-bold subtitle-2", text: "CARBON_MONOXIDE", value: "cSENS_CARBON_MONOXIDE_Data", align: "center" },
      { class: "font-weight-bold subtitle-2", text: "HYDROGEN_Lev", value: "cSENS_HYDROGEN_Lev", align: "center" },
      { class: "font-weight-bold subtitle-2", text: "HYDROGEN", value: "cSENS_HYDROGEN_Data", align: "center" },
      { class: "font-weight-bold subtitle-2", text: "METHAN_Lev", value: "cSENS_METHAN_Lev", align: "center" },
      { class: "font-weight-bold subtitle-2", text: "METHAN", value: "cSENS_METHAN_Data", align: "center" },
      { class: "font-weight-bold subtitle-2", text: "EMERGENCY_Lev", value: "cEMERGENCY_Lev", align: "center" },
      { class: "font-weight-bold subtitle-2", text: "EMERGENCY", value: "cEMERGENCY_Data", align: "center" },
      { class: "font-weight-bold subtitle-2", text: "CARBON_DIOXIDE_Lev", value: "cSENS_CARBON_DIOXIDE_Lev", align: "center" },
      { class: "font-weight-bold subtitle-2", text: "CARBON_DIOXIDE", value: "cSENS_CARBON_DIOXIDE_Data", align: "center" },
      { class: "font-weight-bold subtitle-2", text: "마지막수신일시", value: "cRevDateTime", align: "center" },

      { class: "font-weight-bold subtitle-2", text: "등록일", value: "cCreateDateTime", align: "center", width:150},      
    ],
    Records: [],
    editedIndex: -1,
    // userId(스토어), cDel(golang), cEtc(golang)만 제외하고 테이블의 항목을 설정함 
    editedItem: { 
      cSensorId: "",
      cSensorNm: "",
      cUse: "Y",      
      cDel: "N",
      cCreateDateTime: "",
      cUpdateDateTime: "",
    },
    deletedItem: {
      cSensorId: "",
      cSensorNm: "",
      cUse: "Y",      
      cDel: "N",
      cCreateDateTime: "",
      cUpdateDateTime: "",
    },
    defaultItem: {
      cSensorId: "",
      cSensorNm: "",
      cUse: "Y",      
      cDel: "N",
      cCreateDateTime: "",
      cUpdateDateTime: "",
    }
  }),

  computed: {
    ...mapState(["UserInfo", "ProgramPermissionInfo", "zUse", "zMappingAll", "zDeviceType", "zApState", "zApInOutType"]),
    formTitle() {
      return this.editedIndex === -1 ? "신규 등록" : "항목 수정";
    },
  },

  mounted() {
    this.initialize();
  },

  methods: {    
    onSettingApInfo(data){
      var posData = {        
        cApId: data.cApId,        
        cApType: data.cInOut,        
        cLimitRSSI: data.iLimitRSSI,        
        cCounterFillter: data.iCounterFillter,        
      }

      this.loading = true;
      axios
        .post(BasicInfo.UIL_API + "SettingApInfo", posData, {
          headers: {
            Authorization: this.$store.state.UserInfo.Token
          }
        })
        .then(res => {
          if (res.data.ResultCd == "44") { EventBus.$emit("onTokenExpired"); return; }
          
          if (res.data.ResultCd === "00") {                        
            EventBus.$emit("onShowMsg",false, "전송을 완료했습니다.");
          } else {
            EventBus.$emit("onShowMsg",true,  "(" + res.data.ResultCd + ") " + res.data.Msg);
          }
          this.loading = false;
        })
        .catch(err => {
          EventBus.$emit("onShowMsg",true, ""+err);
          this.loading = false;
        });
    },
    onIPSetSend(data){
      this.iDelIndex = this.Records.indexOf(data);
      this.deletedItem = Object.assign({}, data);
      this.$refs.MsgBoxRef4.RunMsgBoxShow(
        "확인",
        "아이피를 바꾸시겠습니까? \r\n [" +
          this.deletedItem.cApId + "/" + this.deletedItem.cIp +
          "]"
      );
    },


      
    onServerIPSetSend(data){
      this.iDelIndex = this.Records.indexOf(data);
      this.deletedItem = Object.assign({}, data);
      this.$refs.MsgBoxRef3.RunMsgBoxShow(
        "확인",
        "서버 아이피를 바꾸시겠습니까? \r\n [" +
          this.deletedItem.cApId + "/" + this.deletedItem.cServerIp +
          "]"
      );

    },

    initialize() {
      this.cNowSearchKeyWord = "";
      this.cNowCheck= "A",
      this.Search();    
    },
    

    ClearDialog() {      
      this.isEditMode = false;
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedIndex = -1;                      
    },


    goApInfoPage(){
      router.push({name: "APInfo"});
    },

    handleDoubleClick(value, items) { 
       if (!this.ProgramPermissionInfo.okU) return;
       this.editItem(items.item);  
    },

    Search() {
      this.Records = [];
      var posData = {
        cStartDatetime: this.sStartDate + " 00:00:00",  
        cEndDatetime  : this.sEndDate + " 23:59:59",
        cNowCheck: this.cNowCheck,
        cNowSearchKeyWord : this.cNowSearchKeyWord,
      };
      axios
        .post(BasicInfo.UIL_API + "GetSensorInfo", posData, {
          headers: {
            Authorization: this.$store.state.UserInfo.Token
          }
        })
        .then(res => {
          if (res.data.ResultCd == "44") { EventBus.$emit("onTokenExpired"); return; }
          
          if (res.data.ResultCd === "00") {
            this.Records = res.data.Result;            
          } else {
            EventBus.$emit("onShowMsg",true,  "(" + res.data.ResultCd + ") " + res.data.Msg);
          }
        })
        .catch(err => {
          EventBus.$emit("onShowMsg",true, ""+err);
        });
    },

    save() {
      if (this.editedItem.cSensorId == "" ) {
        EventBus.$emit("onShowMsg",true, "Sensor MAC은 필수입력 항목입니다.");
        return;
      }      
      
      var posData = {
        cSiteId: this.$store.state.UserInfo.NowSiteId,
        cUserId: this.$store.state.UserInfo.UserId,      
        cSensorId: this.editedItem.cSensorId,        
        cSensorNm: this.editedItem.cSensorNm,        
        cUse: this.editedItem.cUse,        
        cDel: this.editedItem.cDel,
      }
      
      this.loading = true;      
      axios
        .post(BasicInfo.UIL_API + "SetSensorInfo", posData, {
          headers: {
            Authorization: this.$store.state.UserInfo.Token
          }
        })
        .then(res => {
          if (res.data.ResultCd == "44") { EventBus.$emit("onTokenExpired"); return; }
          
          if (res.data.ResultCd === "00") {
            if (this.isEditMode) {              
              this.editedItem.cUpdateDateTime = res.data.Result[0].cUpdateDateTime;
              Object.assign(this.Records[this.editedIndex], this.editedItem);
            } else {              
              this.Records.push(this.editedItem);
            }
            this.dialog = false;
            EventBus.$emit("onShowMsg",false, "저장되었습니다.");
          } else {
            EventBus.$emit("onShowMsg",true,  "(" + res.data.ResultCd + ") " + res.data.Msg);
          }
          this.loading = false;
        })
        .catch(err => {
          EventBus.$emit("onShowMsg",true, ""+err);
          this.loading = false;
        });
    },
    
    
    close() {      
      this.dialog = false;
      this.isEditMode = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    
    editItem(item) {
      this.isEditMode = true;
      this.editedIndex = this.Records.indexOf(item);   
      this.editedItem = Object.assign({}, item);       
      this.dialog = true;
    },

    
    deleteItem(item) {
      this.iDelIndex = this.Records.indexOf(item);
      this.deletedItem = Object.assign({}, item);
      this.$refs.MsgBoxRef.RunMsgBoxShow(
        "확인",
        "삭제하시겠습니까? \r\n 삭제하시면 복원되지 않습니다. \r\n[" +
          this.deletedItem.cSensorId  + "/" + this.deletedItem.cSensorNm +
          "]"
      );
    },

    
    onMsgBoxFunc(result) {
      if (result === true) {
        //삭제
        var posData = {
          cUserId: this.$store.state.UserInfo.UserId,
          cSiteId: this.$store.state.UserInfo.NowSiteId,
          cSensorId: this.deletedItem.cSensorId,
          cSensorNm: this.deletedItem.cSensorNm,
        };
        axios
          .post(BasicInfo.UIL_API + "DelSensorInfo", posData, {
            headers: {
              Authorization: this.$store.state.UserInfo.Token
            }
          })
          .then(res => {
            if (res.data.ResultCd == "44") { EventBus.$emit("onTokenExpired"); return; }
          
            if (res.data.ResultCd === "00") {
              this.Records.splice(this.iDelIndex, 1); 
              EventBus.$emit("onShowMsg",false, "삭제되었습니다.");
            } else {
              EventBus.$emit("onShowMsg",true, res.data.Msg);
            }
          })
          .catch(err => {
            EventBus.$emit("onShowMsg",true, ""+err);
          });
      }
    },

    resetItem(item) {
      this.iDelIndex = this.Records.indexOf(item);
      this.deletedItem = Object.assign({}, item);
      this.$refs.MsgBoxRef2.RunMsgBoxShow(
        "확인",
        "장비를 리셋하시겠습니까? \r\n [" +
          this.deletedItem.cApId +
          "]"
      );
    },
    
    ExcelExpert(name){
      var r = Util.GetExcel(this.Records, this.headers);
      var animalWS = XLSX.utils.json_to_sheet(r)       
      var wb = XLSX.utils.book_new() // make Workbook of Excel
      XLSX.utils.book_append_sheet(wb, animalWS, name) // sheetAName is name of Worksheet      
      XLSX.writeFile(wb, name + "-" + Util.sNowDate() + '.xlsx'); // name of the file is 'book.xlsx'
    },

    uploadExcel(){
      this.$refs.UploadExcelRef.Show();
    },

    onReadFile(data){
      this.FileRecords = [];
      if (data.length == 0) {
        return
      }

      for (let i = 0; i < data.length; i++) {
        var a = {
          cId : String(data[i].Id),
          cMac : String(data[i].Mac),
          cType : String(data[i].Type),          
          cIp : String(data[i].IP),
          cPort : String(data[i].Port),
          cInOut : String(data[i].InOut),
          cServer : String(data[i].Server),
          cPowerId : String(data[i].PowerId),
          cLimitRSSI : String(data[i].LimitRSSI),
          cCount : String(data[i].Count),          
          cUse : String(data[i].사용여부),
        }

        if (a.cUse == "") {
          a.cUse = "Y";
        }
        this.FileRecords.push(a);
      }      
      this.bReadFile = true;
    }, 

    uploadExcelFile(){      
      var posData = {
        cUserId: this.$store.state.UserInfo.UserId,
        ZData : this.FileRecords,        
      }      
      this.loading2 = true;
      
      axios
        .post(BasicInfo.UIL_API + "UploadExcelApInfo", posData, {
          headers: {
            Authorization: this.$store.state.UserInfo.Token
          }
        })
        .then(res => {          
          if (res.data.ResultCd == "44") { EventBus.$emit("onTokenExpired"); return; }
          
          if (res.data.ResultCd === "00") {            
            EventBus.$emit("onShowMsg",false, "저장했습니다.");
            this.bReadFile = false;
            
          } else {
            EventBus.$emit("onShowMsg",true,  "(" + res.data.ResultCd + ") " + res.data.Msg);
          }
          this.loading2 = false;
        })
        .catch(err => {
          EventBus.$emit("onShowMsg",true, ""+err);
          this.loading2 = false;          
        });
    },  
  }
};
</script>

